import { Component, Input, OnInit } from '@angular/core';
import { SectionDisplayData } from '../../../models/scorecard-processor.model';
import {AiScenario} from '../../../models/top-level-statistic.model';

@Component({
  selector: 'app-calls-heatmap',
  templateUrl: './calls-heatmap.component.html',
  styleUrls: ['./calls-heatmap.component.scss'],
})
export class CallsHeatmapComponent implements OnInit {
  @Input() userType = 'learner'; // 'learner' or 'manager'
  @Input() data: SectionDisplayData[];
  @Input() scenarios: AiScenario[];

  agent2Scenario: { [key: string]: AiScenario } = {};

  constructor() { }

  ngOnInit() {
    if (this.scenarios) {
      this.scenarios.forEach((scenario) => {
        scenario.AiScenarioAgents.forEach((agent) => {
          this.agent2Scenario[agent.agentFirstName] = scenario;
        });
      });
    }
  }

  interpolateColor(scale: number) {
    // Ensure that the scale is between 0 and 100
    scale = Math.max(0, Math.min(100, scale));

    // Define the colors for each stage
    const startColor = { r: 0xe1, g: 0x13, b: 0x13 }; // Red
    const midColor = { r: 0xf1, g: 0x8b, b: 0x41 }; // Orange
    const endColor = { r: 0x06, g: 0xb2, b: 0x17 }; // Green

    let r; let g; let b;

    if (scale <= 50) {
      // Interpolate between startColor and midColor
      const proportion = scale / 50;
      r = Math.round((1 - proportion) * startColor.r + proportion * midColor.r);
      g = Math.round((1 - proportion) * startColor.g + proportion * midColor.g);
      b = Math.round((1 - proportion) * startColor.b + proportion * midColor.b);
    } else {
      // Interpolate between midColor and endColor
      const proportion = (scale - 50) / 50;
      r = Math.round((1 - proportion) * midColor.r + proportion * endColor.r);
      g = Math.round((1 - proportion) * midColor.g + proportion * endColor.g);
      b = Math.round((1 - proportion) * midColor.b + proportion * endColor.b);
    }

    // Convert to a hexadecimal string
    const toHex = (num: number) => num.toString(16).padStart(2, '0').toUpperCase();
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }
}
